export default __webpack_public_path__ + "static/media/coffee-after-cigs-K.34e73b07.mp3";